import React, { useEffect, useRef, useState } from 'react';
import styles from './../addCategoryForm/addCategoryForm.module.css';
import { Close, closeCircle, UploadImg } from '../../Svg';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Country, State } from "country-state-city";
import { addCustomerThunk, editCustomerThunk } from '../../redux/customer/customerSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const EditCustomerForm = () => {

    const { admin } = useSelector((state) => state?.admin)
    const { customerDetails } = useSelector((state) => state.customer);

    const [billingStates, setBillingStates] = useState([]);
    const [shippingStates, setShippingStates] = useState([]);
    const [isPasswordVisible, setPasswordVisible] = useState(false)
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [countries, setCountries] = useState([]);

    // Fetch countries on component mount
    useEffect(() => {
        const countryList = Country.getAllCountries();
        setCountries(countryList);
    }, []);

    // Define the Formik schema
    const {
        errors,
        values,
        handleChange,
        touched,
        setFieldValue,
        isSubmitting,
        setValues,
        handleBlur,
        handleSubmit,
        resetForm
    } = useFormik({
        initialValues: {
            fullName: customerDetails?.fullName || "",
            phone: customerDetails?.phone || "",
            email: customerDetails?.email || "",
            companyName: customerDetails?.companyName || "",
            gstn: customerDetails?.gstn || "",
            password: customerDetails?.password || "",
            confirmPassword: customerDetails?.password || "",
            billingAddress: customerDetails?.billingAddress || [{
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            }],
            shippingAddress: customerDetails?.shippingAddress || [{
                factoryUnits: "",
                streetAddress: "",
                country: "",
                state: "",
                zipCode: "",
            }],
            activeStatus: customerDetails?.activeStatus || "",
            category: {
                status: customerDetails?.category?.status || ""
            },
            admin: customerDetails?.admin || "",
            level: customerDetails?.level || "",
            creditTerms: customerDetails?.creditTerms || "",
            status: "APPROVED"

        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            fullName: Yup.string().required('Name is required'),
            phone: Yup.string().required('Phone number is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            companyName: Yup.string().required('Company name is required'),
            gstn: Yup.string().required('GSTN number is required'),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
            billingAddress: Yup.array().of(
                Yup.object().shape({
                    factoryUnits: Yup.string().required("Required"),
                    streetAddress: Yup.string().required("Required"),
                    country: Yup.string().required("Required"),
                    state: Yup.string().required("Required"),
                    zipCode: Yup.string().required("Required"),
                })
            ),
            shippingAddress: Yup.array().of(
                Yup.object().shape({
                    factoryUnits: Yup.string().required("Required"),
                    streetAddress: Yup.string().required("Required"),
                    country: Yup.string().required("Required"),
                    state: Yup.string().required("Required"),
                    zipCode: Yup.string().required("Required"),
                })
            ),
            activeStatus: Yup.string().required('status is required'),
        }),

        onSubmit: async (values) => {
            const formattedValues = {
                ...values,
                admin: values.admin ? values.admin : null
            };
            const data = {
                id: customerDetails?._id,
                values: formattedValues
            };
            const status = await dispatch(editCustomerThunk(data));

            if (status.payload === 200) {
                navigate(-1);
            }
        },
    });



    const handleCountryChange = (type, index, value) => {
        const selectedCountry = countries.find((country) => country.name === value);
        if (selectedCountry) {
            const states = State.getStatesOfCountry(selectedCountry.isoCode);

            if (type === "billingAddress") {
                const updatedStates = [...billingStates];
                updatedStates[index] = states;
                setBillingStates(updatedStates);
            } else if (type === "shippingAddress") {
                const updatedStates = [...shippingStates];
                updatedStates[index] = states;
                setShippingStates(updatedStates);
            }
        }

        setFieldValue(`${type}[${index}].country`, value);
        setFieldValue(`${type}[${index}].state`, ""); // Reset state
    };





    useEffect(() => {
        values.billingAddress?.forEach((address, index) => {
            if (address.country) {
                const selectedCountry = countries.find(
                    (country) => country.name === address.country
                );
                if (selectedCountry) {
                    const states = State.getStatesOfCountry(selectedCountry.isoCode);
                    setBillingStates((prevStates) => {
                        const updatedStates = [...prevStates];
                        updatedStates[index] = states;
                        return updatedStates;
                    });
                }
            }
        });

        // Initialize states for shipping addresses
        values.shippingAddress?.forEach((address, index) => {
            if (address.country) {
                const selectedCountry = countries.find(
                    (country) => country.name === address.country
                );
                if (selectedCountry) {
                    const states = State.getStatesOfCountry(selectedCountry.isoCode);
                    setShippingStates((prevStates) => {
                        const updatedStates = [...prevStates];
                        updatedStates[index] = states;
                        return updatedStates;
                    });
                }
            }
        });
    }, [values.billingAddress, values.shippingAddress, countries]);



    return (
        <>
            <form onSubmit={handleSubmit} className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo}>
                    <div className={styles.formSection}>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>General Information</h2>

                            <label className={styles.addCatLabel}>
                                Full name
                                <input
                                    type="text"
                                    name="fullName"
                                    placeholder="Full name"
                                    className={styles.addCatInput}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.fullName}
                                />
                                {touched.fullName && errors.fullName ? (
                                    <div className={styles.errorText}>{errors.fullName}</div>
                                ) : null}
                            </label>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Phone number
                                    <input
                                        type="phone"
                                        name="phone"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.phone}
                                    />
                                    {touched.phone && errors.phone ? (
                                        <div className={styles.errorText}>{errors.phone}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Email id
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.email}
                                    />
                                    {touched.email && errors.email ? (
                                        <div className={styles.errorText}>{errors.email}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Company name
                                    <input
                                        type="text"
                                        name="companyName"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.companyName}
                                    />
                                    {touched.companyName && errors.companyName ? (
                                        <div className={styles.errorText}>{errors.companyName}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    GSTN number
                                    <input
                                        type="text"
                                        name="gstn"
                                        placeholder="Enter"
                                        className={styles.addCatInput}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.gstn}
                                    />
                                    {touched.gstn && errors.gstn ? (
                                        <div className={styles.errorText}>{errors.gstn}</div>
                                    ) : null}
                                </label>
                            </div>
                            <div style={{ display: 'flex', gap: '14px' }}>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            name="password"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.password}
                                        />
                                        <FontAwesomeIcon
                                            onClick={() => setPasswordVisible(!isPasswordVisible)}
                                            icon={isPasswordVisible ? faEyeSlash : faEye}

                                            className={styles.loginpasswordIcon}
                                        />
                                    </div>
                                    {touched.password && errors.password ? (
                                        <div className={styles.errorText}>{errors.password}</div>
                                    ) : null}
                                </label>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Confirm password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type={isConfirmPasswordVisible ? "text" : "password"}
                                            name="confirmPassword"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.confirmPassword}
                                        />
                                        <FontAwesomeIcon
                                            icon={isConfirmPasswordVisible ? faEyeSlash : faEye}

                                            className={styles.loginpasswordIcon}
                                            onClick={() => setConfirmPasswordVisible(!isConfirmPasswordVisible)}

                                        />
                                    </div>
                                    {touched.confirmPassword && errors.confirmPassword ? (
                                        <div className={styles.errorText}>{errors.confirmPassword}</div>
                                    ) : null}
                                </label>
                            </div>



                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Billing address</h2>
                            {values?.billingAddress?.map((i, index) => (
                                <>

                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>

                                            Factory Units
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].factoryUnits`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.factoryUnits}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>

                                            {touched.billingAddress?.[index]?.factoryUnits &&
                                                errors.billingAddress?.[index]?.factoryUnits && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].factoryUnits}
                                                    </div>
                                                )}


                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                            Street, area, city
                                            <input
                                                type="text"
                                                name={`billingAddress[${index}].streetAddress`}
                                                placeholder="Enter street address"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.streetAddress}
                                                className={styles.addCatInput}
                                            />
                                            {touched.billingAddress?.[index]?.streetAddress &&
                                                errors.billingAddress?.[index]?.streetAddress && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].streetAddress}
                                                    </div>
                                                )}
                                        </label>

                                    </div>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Country
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].country`}
                                                value={i.country}
                                                onChange={(e) =>
                                                    handleCountryChange("billingAddress", index, e.target.value)
                                                }
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>{countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {touched.billingAddress?.[index]?.country &&
                                                errors.billingAddress?.[index]?.country && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].country}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            State
                                            <select
                                                className={styles.addCatSelect}
                                                name={`billingAddress[${index}].state`}
                                                value={i?.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {billingStates[index]?.map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.billingAddress?.[index]?.state &&
                                                errors.billingAddress?.[index]?.state && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].state}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Zip code
                                            <input
                                                type="text"
                                                name={`billingAddress[${index}].zipCode`}
                                                placeholder="Enter Zip code"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.zipCode}
                                                className={styles.addCatInput}
                                            />
                                            {touched.billingAddress?.[index]?.zipCode &&
                                                errors.billingAddress?.[index]?.zipCode && (
                                                    <div className={styles.errorText}>
                                                        {errors.billingAddress[index].zipCode}
                                                    </div>
                                                )}
                                        </label>
                                    </div>
                                </>
                            ))}
                        </div>
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Shipping address</h2>
                            {values?.shippingAddress?.map((i, index) => (

                                <>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Factory Units
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].factoryUnits`}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.factoryUnits}
                                            >
                                                <option value="">Select</option>
                                                <option value="Unit 1">Unit 1</option>
                                                <option value="Unit 2">Unit 2</option>
                                            </select>
                                            {touched.shippingAddress?.[index]?.factoryUnits &&
                                                errors.shippingAddress?.[index]?.factoryUnits && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].factoryUnits}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '67%' }}>
                                            Street, area, city
                                            <input
                                                type="text"
                                                name={`shippingAddress[${index}].streetAddress`}
                                                placeholder="Enter street address"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.streetAddress}
                                                className={styles.addCatInput}
                                            />
                                            {touched.shippingAddress?.[index]?.streetAddress &&
                                                errors.shippingAddress?.[index]?.streetAddress && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].streetAddress}
                                                    </div>
                                                )}
                                        </label>

                                    </div>
                                    <div style={{ display: 'flex', gap: '14px' }}>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Country
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].country`}
                                                value={i.country}
                                                onChange={(e) =>
                                                    handleCountryChange("shippingAddress", index, e.target.value)
                                                }
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {countries.map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}

                                            </select>
                                            {touched.shippingAddress?.[index]?.country &&
                                                errors.shippingAddress?.[index]?.country && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].country}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            State
                                            <select
                                                className={styles.addCatSelect}
                                                name={`shippingAddress[${index}].state`}
                                                value={i?.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            >
                                                <option value="">Select</option>
                                                {shippingStates[index]?.map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {touched.shippingAddress?.[index]?.state &&
                                                errors.shippingAddress?.[index]?.state && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].state}
                                                    </div>
                                                )}
                                        </label>
                                        <label className={styles.addCatLabel} style={{ width: '33%' }}>
                                            Zip code
                                            <input
                                                type="text"
                                                name={`shippingAddress[${index}].zipCode`}
                                                placeholder="Enter Zip code"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={i?.zipCode}
                                                className={styles.addCatInput}
                                            />
                                            {touched.shippingAddress?.[index]?.zipCode &&
                                                errors.shippingAddress?.[index]?.zipCode && (
                                                    <div className={styles.errorText}>
                                                        {errors.shippingAddress[index].zipCode}
                                                    </div>
                                                )}
                                        </label>
                                    </div>
                                </>
                            ))
                            }
                        </div>
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" className={styles.cancelButton} onClick={() => resetForm()}><Close />Cancel</button>
                        <button type="submit" className={styles.updateButton} disabled={isSubmitting}>{isSubmitting ? 'please wait' : "Update Customer"}</button>
                    </div>
                </div>

                <div className={styles.thumbnain}>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}> Status</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="activeStatus"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.activeStatus}
                            >
                                <option value="">Select...</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">Inactive</option>
                            </select>
                            {touched.activeStatus && errors.activeStatus && (
                                <div className={styles.errorText}>{errors.activeStatus}</div>
                            )}
                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Level </h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Status
                            <select
                                name="level"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.level}
                            >
                                <option value="">Select...</option>
                                <option value="SILVER">Silver</option>
                                <option value="PLATINUM">Platinum</option>
                                <option value="GOLD">Gold</option>
                            </select>

                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>  Admin manager</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Select Admin
                            <select
                                name="admin"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.admin}
                            >
                                <option value="">Select...</option>
                                {admin?.map((row) => (

                                    <option key={row?._id} value={row?._id}>{row?.name}</option>
                                ))
                                }
                            </select>

                        </label>
                    </div>
                    <div className={styles.card}>
                        <h2 className={styles.addCatH2}>Customer Credit</h2>
                        <label style={{ paddingBottom: '10px', display: "block" }}>
                            Credit Terms
                            <select
                                name="creditTerms"
                                className={styles.addCatSelect}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.creditTerms}
                            >
                                <option value="">Select...</option>
                                <option value="ADVANCE">100% Advance Payment</option>
                                <option value="15_DAYS">Net 15 Days</option>
                                <option value="30_DAYS">Net 30 Days</option>
                                <option value="45_DAYS">Net 45 Days</option>
                                <option value="60_DAYS">Net 60 Days</option>
                                <option value="90_DAYS">Net 90 Days</option>
                            </select>
                        </label>
                    </div>
                </div>

            </form>
        </>
    );
};

export default EditCustomerForm;
